import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_PARTNER_GET_BY_SLUG } from 'api/actionTypes';

export default async function loadPartnerBySlug(
  { state, apiClient },
  { slug, forceRefresh = false },
) {
  typeCheck('slug::NonEmptyString', slug);

  const currentPartnerStatePath = ['partners', 'bySlug', slug];
  if (state.get(currentPartnerStatePath) && !forceRefresh) {
    return state.get(currentPartnerStatePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_BY_SLUG,
    queryId: slug,
    state: state,
    payload: {
      slug,
    },
    onSuccess(partner) {
      if (partner) {
        state.set(currentPartnerStatePath, partner);
      }
    },
  });
}
